import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.scss']
})
export class RewardsComponent implements OnInit {
  rewardList:any 
  page:any = 1
  getPaginationCount: any;
  totalPages:any
  Image: any;
  Search:any = ''
  constructor(
    private Router : Router,
    private apiService : ApiService,
    private apiConfig : ApiConfiguration,
    private http : HttpClient,
    private toast : ToastClientService,
    private modalService : NgbModal
  ) { }

  ngOnInit() {
    this.getRewardlist()
  }


  createRewards(){
    let Configflags = {
      'createReward': true,
      'whitelistUser' : false
    }

    localStorage.setItem('configFlags',JSON.stringify(Configflags))
    this.Router.navigate([`/hubAdmin/reward-setup/0`])
  }

  editRewards(data){
    console.log(data)
    let Configflags = {
      'createReward': true,
      'whitelistUser' : true
    }
    localStorage.setItem('configFlags',JSON.stringify(Configflags))
    this.Router.navigate([`/hubAdmin/reward-setup/${data.id}`])
  }


  reset(){
    this.Search = ''
    this.getRewardlist()
  }


  getRewardlist(){
    this.apiService.getHeaders(this.apiConfig.getRewardlist + `?page=${this.page}&search=${this.Search}`)
    .subscribe((res:any)=>{
      console.log(res)
      this.rewardList = res.body.data
      this.getPaginationCount = res.headers.get("X-Pagination-Total-Count")
      this.totalPages = res.headers.get('X-Pagination-Per-Page')
      this.rewardList.forEach(value => {
        value.is_checked = false
        value.is_second_checked = false
        value.is_third_checked = false
      })
    })
  }

  showImage(img,modal){
    this.Image = img
    this.modalService.open(modal,{
      centered : true,
      size : 'md'
    })

  }


  show_shrt_desc(data) {
    data.is_checked = !data.is_checked
  }
  show_desc(data){
    data.is_second_checked = !data.is_second_checked
  }
  show_succes_msg(data){
    data.is_third_checked = !data.is_third_checked
  }

  paginationClick(page){
    this.page = page;
    this.getRewardlist();
  }

  toggleStatus(data){
    console.log(data)
    let payload = {
      "id" : data.id,
      "flag" : 1,
    }
    this.apiService.post(this.apiConfig.disableReward,payload)
    .subscribe((res:any)=>{
      console.log(res)
      this.toast.Success(res.data.message)
      this.rewardList()
    })

  }
}
  